module.exports = __webpack_public_path__ + "static/media/cancel-order.ec83f6be.svg";